module.exports = __webpack_public_path__ + "static/media/projectileDiagram2.e9ab9d8e.svg";